module.exports = __webpack_public_path__ + "build/img/booklet-example-1.81f1f9f8.jpg";